/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  Event,
  EventCreationArgs,
  EventDeleteArgs,
  EventUpdateArgs,
  EventsCountResponse,
  GetEventsAdminParams,
  GetPastMovingworldsEventsParams,
  GetUpcomingEventsParams,
  HTTPValidationError,
} from './platformapi.schemas';

import getEventsAdminMutator from '../custom-axios-instance';
import countEventsAdminMutator from '../custom-axios-instance';
import createEventMutator from '../custom-axios-instance';
import deleteEventMutator from '../custom-axios-instance';
import updateEventMutator from '../custom-axios-instance';
import countEventsMutator from '../custom-axios-instance';
import getPastMovingworldsEventsMutator from '../custom-axios-instance';
import getUpcomingEventsMutator from '../custom-axios-instance';

/**
 * Retrieves currently available events
 * @summary Get Events Admin
 */
export const getEventsAdmin = (params: GetEventsAdminParams, signal?: AbortSignal) => {
  return getEventsAdminMutator<Event[]>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/events/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEventsAdminQueryKey = (params?: GetEventsAdminParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/events/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEventsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetEventsAdminParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsAdmin>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventsAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsAdmin>>> = ({ signal }) =>
    getEventsAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsAdmin>>>;
export type GetEventsAdminQueryError = void | HTTPValidationError;

export function useGetEventsAdmin<
  TData = Awaited<ReturnType<typeof getEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetEventsAdminParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsAdmin>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getEventsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventsAdmin<
  TData = Awaited<ReturnType<typeof getEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetEventsAdminParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsAdmin>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getEventsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventsAdmin<
  TData = Awaited<ReturnType<typeof getEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetEventsAdminParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsAdmin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Events Admin
 */

export function useGetEventsAdmin<
  TData = Awaited<ReturnType<typeof getEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetEventsAdminParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsAdmin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEventsAdminQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Counts the number of events regardless of date
 * @summary Count Events Admin
 */
export const countEventsAdmin = (signal?: AbortSignal) => {
  return countEventsAdminMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/events/count`,
    method: 'GET',
    signal,
  });
};

export const getCountEventsAdminQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/events/count`] as const;
};

export const getCountEventsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof countEventsAdmin>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEventsAdmin>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountEventsAdminQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countEventsAdmin>>> = ({ signal }) =>
    countEventsAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countEventsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountEventsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof countEventsAdmin>>>;
export type CountEventsAdminQueryError = void | HTTPValidationError;

export function useCountEventsAdmin<
  TData = Awaited<ReturnType<typeof countEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEventsAdmin>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countEventsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countEventsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountEventsAdmin<
  TData = Awaited<ReturnType<typeof countEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEventsAdmin>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countEventsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countEventsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountEventsAdmin<
  TData = Awaited<ReturnType<typeof countEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEventsAdmin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Events Admin
 */

export function useCountEventsAdmin<
  TData = Awaited<ReturnType<typeof countEventsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEventsAdmin>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountEventsAdminQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new event
 * @summary Create Event
 */
export const createEvent = (eventCreationArgs: EventCreationArgs, signal?: AbortSignal) => {
  return createEventMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/events/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eventCreationArgs,
    signal,
  });
};

export const getCreateEventMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: EventCreationArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: EventCreationArgs },
  TContext
> => {
  const mutationKey = ['createEvent'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    { data: EventCreationArgs }
  > = (props) => {
    const { data } = props ?? {};

    return createEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventMutationResult = NonNullable<Awaited<ReturnType<typeof createEvent>>>;
export type CreateEventMutationBody = EventCreationArgs;
export type CreateEventMutationError = void | HTTPValidationError;

/**
 * @summary Create Event
 */
export const useCreateEvent = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent>>,
      TError,
      { data: EventCreationArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: EventCreationArgs },
  TContext
> => {
  const mutationOptions = getCreateEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes an event
 * @summary Delete Event
 */
export const deleteEvent = (eventDeleteArgs: EventDeleteArgs, signal?: AbortSignal) => {
  return deleteEventMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/events/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eventDeleteArgs,
    signal,
  });
};

export const getDeleteEventMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEvent>>,
    TError,
    { data: EventDeleteArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEvent>>,
  TError,
  { data: EventDeleteArgs },
  TContext
> => {
  const mutationKey = ['deleteEvent'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEvent>>,
    { data: EventDeleteArgs }
  > = (props) => {
    const { data } = props ?? {};

    return deleteEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>;
export type DeleteEventMutationBody = EventDeleteArgs;
export type DeleteEventMutationError = void | HTTPValidationError;

/**
 * @summary Delete Event
 */
export const useDeleteEvent = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEvent>>,
      TError,
      { data: EventDeleteArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEvent>>,
  TError,
  { data: EventDeleteArgs },
  TContext
> => {
  const mutationOptions = getDeleteEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an existing event
 * @summary Update Event
 */
export const updateEvent = (eventUpdateArgs: EventUpdateArgs, signal?: AbortSignal) => {
  return updateEventMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/events/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eventUpdateArgs,
    signal,
  });
};

export const getUpdateEventMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEvent>>,
    TError,
    { data: EventUpdateArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { data: EventUpdateArgs },
  TContext
> => {
  const mutationKey = ['updateEvent'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvent>>,
    { data: EventUpdateArgs }
  > = (props) => {
    const { data } = props ?? {};

    return updateEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvent>>>;
export type UpdateEventMutationBody = EventUpdateArgs;
export type UpdateEventMutationError = void | HTTPValidationError;

/**
 * @summary Update Event
 */
export const useUpdateEvent = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEvent>>,
      TError,
      { data: EventUpdateArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { data: EventUpdateArgs },
  TContext
> => {
  const mutationOptions = getUpdateEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Counts the number of events
 * @summary Count Events
 */
export const countEvents = (signal?: AbortSignal) => {
  return countEventsMutator<EventsCountResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/events/count`,
    method: 'GET',
    signal,
  });
};

export const getCountEventsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/events/count`] as const;
};

export const getCountEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof countEvents>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEvents>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countEvents>>> = ({ signal }) =>
    countEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountEventsQueryResult = NonNullable<Awaited<ReturnType<typeof countEvents>>>;
export type CountEventsQueryError = void | HTTPValidationError;

export function useCountEvents<
  TData = Awaited<ReturnType<typeof countEvents>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countEvents>>,
          TError,
          Awaited<ReturnType<typeof countEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountEvents<
  TData = Awaited<ReturnType<typeof countEvents>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countEvents>>,
          TError,
          Awaited<ReturnType<typeof countEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountEvents<
  TData = Awaited<ReturnType<typeof countEvents>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Events
 */

export function useCountEvents<
  TData = Awaited<ReturnType<typeof countEvents>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountEventsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves past MovingWorlds events
 * @summary Get Past Movingworlds Events
 */
export const getPastMovingworldsEvents = (
  params: GetPastMovingworldsEventsParams,
  signal?: AbortSignal,
) => {
  return getPastMovingworldsEventsMutator<Event[]>({
    url: `${import.meta.env['VITE_API_HOST']}/events/past-movingworlds`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetPastMovingworldsEventsQueryKey = (params?: GetPastMovingworldsEventsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/events/past-movingworlds`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPastMovingworldsEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetPastMovingworldsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastMovingworldsEvents>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPastMovingworldsEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPastMovingworldsEvents>>> = ({
    signal,
  }) => getPastMovingworldsEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPastMovingworldsEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPastMovingworldsEvents>>
>;
export type GetPastMovingworldsEventsQueryError = void | HTTPValidationError;

export function useGetPastMovingworldsEvents<
  TData = Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetPastMovingworldsEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastMovingworldsEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
          TError,
          Awaited<ReturnType<typeof getPastMovingworldsEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPastMovingworldsEvents<
  TData = Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetPastMovingworldsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastMovingworldsEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
          TError,
          Awaited<ReturnType<typeof getPastMovingworldsEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPastMovingworldsEvents<
  TData = Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetPastMovingworldsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastMovingworldsEvents>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Past Movingworlds Events
 */

export function useGetPastMovingworldsEvents<
  TData = Awaited<ReturnType<typeof getPastMovingworldsEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetPastMovingworldsEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPastMovingworldsEvents>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPastMovingworldsEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves upcoming events
 * @summary Get Upcoming Events
 */
export const getUpcomingEvents = (params: GetUpcomingEventsParams, signal?: AbortSignal) => {
  return getUpcomingEventsMutator<Event[]>({
    url: `${import.meta.env['VITE_API_HOST']}/events/upcoming`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetUpcomingEventsQueryKey = (params?: GetUpcomingEventsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/events/upcoming`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUpcomingEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetUpcomingEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUpcomingEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingEvents>>> = ({ signal }) =>
    getUpcomingEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpcomingEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUpcomingEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpcomingEvents>>
>;
export type GetUpcomingEventsQueryError = void | HTTPValidationError;

export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetUpcomingEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingEvents>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetUpcomingEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingEvents>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetUpcomingEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Upcoming Events
 */

export function useGetUpcomingEvents<
  TData = Awaited<ReturnType<typeof getUpcomingEvents>>,
  TError = void | HTTPValidationError,
>(
  params: GetUpcomingEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingEvents>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUpcomingEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
